import { useState, useEffect, createContext, useContext } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import LocationSelector from "@/components/LocationSelector";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import PriceList from "@/components/PriceList";
import BookingWizard from "@/components/BookingWizard";
import AboutSection from "@/components/AboutSection";
import Footer from "@/components/Footer";
import ChatBot from "@/components/ChatBot";
import AdminPanel from "@/components/AdminPanel";
import PromoPopup from "@/components/PromoPopup";
import { Toaster } from "@/components/ui/sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Context for location & data
export const AppContext = createContext();

export const useApp = () => useContext(AppContext);

const MainPage = () => {
  const { selectedLocation } = useApp();
  const [showAdmin, setShowAdmin] = useState(false);

  return (
    <div className="min-h-screen bg-[#050505]">
      <Navigation />
      <div id="booking" className="pt-20">
        <BookingWizard />
      </div>
      <HeroSection />
      <ServicesSection />
      <PriceList />
      <AboutSection />
      <Footer onAdminClick={() => setShowAdmin(true)} />
      <ChatBot />
      <div className="noise-overlay" />
      {showAdmin && <AdminPanel onClose={() => setShowAdmin(false)} />}
    </div>
  );
};

function App() {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [packages, setPackages] = useState([]);
  const [addons, setAddons] = useState([]);
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [pkgRes, addonRes, locRes] = await Promise.all([
          axios.get(`${API}/packages`),
          axios.get(`${API}/addons`),
          axios.get(`${API}/locations`),
        ]);
        setPackages(pkgRes.data);
        setAddons(addonRes.data);
        setLocations(locRes.data);
      } catch (e) {
        console.error("Failed to fetch data:", e);
      }
    };
    fetchData();
  }, []);

  const contextValue = {
    selectedLocation,
    setSelectedLocation,
    packages,
    addons,
    locations,
    API,
  };

  return (
    <AppContext.Provider value={contextValue}>
      <Toaster position="top-right" theme="dark" />
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              selectedLocation ? (
                <MainPage />
              ) : (
                <LocationSelector />
              )
            }
          />
        </Routes>
      </BrowserRouter>
    </AppContext.Provider>
  );
}

export default App;
